import Swiper from 'swiper';

class ContentSwitcher {
  private swiper: Swiper | null = null;
  private navigationItems: NodeListOf<HTMLElement>;
  private activeClass: string = 'content-switcher__navigation-item--active';

  constructor() {
    this.navigationItems = document.querySelectorAll('.content-switcher__navigation-item');
    this._init();
    this._bindEvents();
  }

  private _init() {
    const swiperElement = document.querySelector('.content-switcher__swiper');
    if (swiperElement) {
      this.swiper = new Swiper(swiperElement as HTMLElement, {
        direction: 'horizontal',
        slidesPerView: 1,
        effect: 'fade',
        autoHeight: true,
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: false,
        initialSlide: 0,
        on: {
          init: () => {
            this._updateNavigation();
          },
          slideChange: () => {
            this._updateNavigation();
          },
        },
      });
    }
  }

  private _bindEvents() {
    this.navigationItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        if (this.swiper) {
          this.swiper.slideTo(index);
        }
      });
    });
  }

  private _updateNavigation() {
    if (this.swiper) {
      const activeIndex = this.swiper.activeIndex;

      this.navigationItems.forEach((item, index) => {
        if (index === activeIndex) {
          item.classList.add(this.activeClass);
        } else {
          item.classList.remove(this.activeClass);
        }
      });
    }
  }
}

// Export pour pouvoir l'utiliser dans d'autres fichiers si nécessaire
export default ContentSwitcher;

// Initialisation
document.addEventListener('DOMContentLoaded', () => {
  new ContentSwitcher();
});
